var isPrototypeOf = require('../../internals/object-is-prototype-of');
var method = require('../array/virtual/concat');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.concat;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.concat) ? method : own;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/instance/concat.js
// module id = 387
// module chunks = 0 1